import axios, { AxiosInstance } from 'axios';

interface ExtendedAxiosInstance extends AxiosInstance {
  formatError: (error: any, defaultMessage?: string) => string;
}

const formatErrorMessage = (error: any, defaultMessage?: string): string => {
  const errors = error.response?.data?.errors;
  if (typeof errors === 'string') {
    return errors || defaultMessage || 'An error occurred.';
  }
  return (
    errors?.map((e: any) => e.detail || e)?.join('\n') ||
    defaultMessage ||
    'An error occurred.'
  );
};

const api = axios.create({}) as ExtendedAxiosInstance;
api.defaults.headers.common['WEB-CLIENT'] = 'react';

api.formatError = formatErrorMessage;

export default api;
